import { useEffect, useState } from 'react';
import './Zoom.css';
import SideBarSkeleton from '../../Component/SideBarSkeleton';
import { Get } from '../../Axios/AxiosFunctions';
import Loader from '../../Component/Loader';
import { useDispatch, useSelector } from 'react-redux';
import MeetingDetailsDialog from './MeetingDetailsDialog';
import AssignContactDialog from './AssignContactDialog';
import axios from 'axios';
import { Tabs, Tab, Button, Typography, Box } from '@mui/material';
import { apiUrl } from '../../config/apiUrl';
import CreateMeeting from './Meeting';
import Outlook from '../Outlook';
import { setOutlookAuthenticated } from '../../store/auth/authSlice';
import { getTimezoneName } from '../../utils/timeUtils';
import { outlookAuth, startOutlookLogin } from '../../utils/outlook';
/**
 * Zoom component displays a calendar of Zoom meetings, allows navigation between views,
 * handles meeting and user data fetching, and provides dialogs for meeting details and contact assignment.
 *
 * @component
 */

const Zoom = () =>
{


  const [ activeView, setActiveView ] = useState( 'month' );
  const [ currentDate, setCurrentDate ] = useState( new Date() );
  const [ isLoading, setIsLoading ] = useState( false );
  const [ meetings, setMeetings ] = useState( [] );
  const [ users, setUsers ] = useState( [] );

  const [ selectedMeeting, setSelectedMeeting ] = useState( null );

  const [ showMeetingDialog, setShowMeetingDialog ] = useState( false );

  const [ selectedSummary, setSelectedSummary ] = useState( null );
  const [ zoomToken, setZoomToken ] = useState( '' );


  useEffect( () =>
  {
    const zoomToken = localStorage.getItem( 'zoom_access_token' );
    setZoomToken( zoomToken );
  }, [] );

  const [ showAssignDialog, setShowAssignDialog ] = useState( false );
  const dispatch = useDispatch();
  const {
    access_token: accessToken,
    company_id: companyId,
    outlookAuthenticated: outlookAuthenticated,
    user,
  } = useSelector( ( state ) => state?.authReducer );

  const [ timezone, setTimezone ] = useState( user?.timezone || getTimezoneName() )

  console.log( "ahsan111", user );
  useEffect( () =>
  {
    console.log( selectedMeeting );
  }, [ selectedMeeting ] );

  const userId = useSelector( ( state ) => state.authReducer.user?._id );

  /**
   * Fetches Zoom meetings and Outlook events, filters and transforms them for display.
   * Updates the meetings state.
   *
   * @async
   * @returns {Promise<void>}
   */
  const fetchMeetings = async () =>
  {
    const route = `${apiUrl}/api/v1/zoom/meetings`;

    let outlookEvents = [];

    try
    {
      const eventsResponse = await axios.get( `${apiUrl}/outlook/events`, outlookAuth( accessToken ) );

      outlookEvents = eventsResponse.data;
      console.log( "outlookEvents", outlookEvents );
    } catch ( error )
    {
      console.error( 'Error fetching events:', error );

      alert( 'Could not fetch Outlook calendar events' );

      return;
    }

    const response = await Get( route, accessToken, null, true, ( err ) =>
    {
      console.error( 'Error fetching meetings:', err );
    } );

    if ( response?.data?.success )
    {
      const zoomMeetings = response.data.data;
      const validMeetings = zoomMeetings.filter( ( meeting ) =>
      {
        return outlookEvents.some( ( event ) =>
          event?.body?.content?.includes( meeting._id ),
        );
      } );
      // Get unmatched meetings (without Outlook events)
      const unmatchedMeetings = zoomMeetings.filter( ( meeting ) =>
      {
        return !outlookEvents.some( ( event ) =>
          event?.body?.content?.includes( meeting._id ),
        );
      } );

      const unmatchedOutlookEvents = outlookEvents.filter( ( event ) =>
      {
        return !zoomMeetings.some( ( meeting ) =>
          event?.body?.content?.includes( meeting._id )
        );
      } );

      console.log( "unmatchedOutlookEvents", unmatchedOutlookEvents );
      // Transform ALL meetings (both matched and unmatched)
      const transformedMeetings = [
        // ...validMeetings.map(transformMeeting),
        // ...unmatchedMeetings.map(transformMeeting),
        ...unmatchedOutlookEvents.map( transformOutlookEvent ),
      ];

      function transformMeeting( meeting )
      {
        const utcDate = new Date( meeting.start_time );

        return {
          id: meeting._id,
          organizerId: meeting.organizerId,
          organizerFname: meeting.organizerFname,
          organizerLname: meeting.organizerLname,
          organizerEmail: meeting.organizerEmail,
          date: utcDate, // Store as UTC date
          utcDate: utcDate, // Keep original UTC date for reference
          time: utcDate.toLocaleTimeString( 'en-US', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: timezone, // Convert to user's timezone
          } ),
          title: meeting.topic,
          type: 'meeting',
          emails: meeting.emails,
          numbers: meeting.numbers,
          join_url: meeting.join_url,
          duration: meeting.duration,
          hasOutlookEvent: outlookEvents.some( ( e ) =>
            e?.body?.content?.includes( meeting._id ),
          ),
        };
      }

      function convertToTimeZone( utcDateStr, timeZone )
      {
        // Ensure the string is UTC (ends with Z)
        if ( !utcDateStr.endsWith( "Z" ) )
        {
          utcDateStr = utcDateStr + "Z";
        }

        const utcDate = new Date( utcDateStr );

        // Format only time with AM/PM
        return new Intl.DateTimeFormat( "en-US", {
          timeZone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        } ).format( utcDate );
      }

      function convertDateToTimeZone( utcDateStr1, timeZone )
      {
        // Make sure we always deal with a string
        let utcDateStr = String( utcDateStr1 );

        // Add Z if not present (to mark as UTC)
        if ( !utcDateStr.endsWith( "Z" ) )
        {
          utcDateStr = utcDateStr + "Z";
        }

        const utcDate = new Date( utcDateStr );

        // Format only time with AM/PM
        return new Intl.DateTimeFormat( "en-US", {
          timeZone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false
        } ).format( utcDate );
      }

      function extractZoomMeetingId( content )
      {
        if ( !content ) return null;

        // Regex to match Zoom join URL and capture meeting ID
        const match = content.match( /zoom\.us\/j\/(\d+)/ );
        return match ? match[ 1 ] : null;
      }
      function transformOutlookEvent( event )
      {
        // Extract date and time from Outlook event
        const eventDate = new Date( event.start?.dateTime || event.createdDateTime );
        let utcDate = new Date( event.start?.dateTime || event.createdDateTime );


        // Extract emails from attendees
        const emails = event.attendees?.map( attendee =>
          attendee.emailAddress?.address
        ).filter( email => email ) || [];

        // Add organizer email if available
        if ( event.organizer?.emailAddress?.address &&
          !emails.includes( event.organizer.emailAddress.address ) )
        {
          emails.push( event.organizer.emailAddress.address );
        }

        // Extract phone numbers - you might need to parse from body content or other fields
        const numbers = extractPhoneNumbersFromEvent( event );

        // Calculate duration in minutes
        const duration = calculateEventDuration( event );

        const zoomMeetingId = extractZoomMeetingId( event.body?.content );

        return {
          // id: event.id || `outlook-${Date.now()}`,
          id: zoomMeetingId || '',
          organizerId: event.organizer?.emailAddress?.name || 'Outlook Event',
          organizerFname: event.organizer?.emailAddress?.name?.split( ' ' )[ 0 ] || 'Outlook',
          organizerLname: event.organizer?.emailAddress?.name?.split( ' ' ).slice( 1 ).join( ' ' ) || 'Event',
          organizerEmail: event.organizer?.emailAddress?.address || '',
          date: utcDate, // Store as UTC date
          utcDate: convertDateToTimeZone( utcDate, timezone ), // Keep original UTC date for reference
          // time: utcDate.toLocaleTimeString('en-US', {
          //   hour: '2-digit',
          //   minute: '2-digit',
          //   timeZone: timezone, // Convert to user's timezone
          // }),
          time: convertToTimeZone( event.start?.dateTime, timezone ),
          start_time: event.start?.dateTime,
          end_time: event.end?.dateTime,
          // time:event.start?.dateTime,
          title: event.subject || 'Outlook Event',
          type: 'outlook',
          emails: emails,
          numbers: numbers,
          join_url: event.onlineMeeting?.joinUrl || event.onlineMeetingUrl || event.webLink || '',
          duration: duration,
          hasZoomMeeting: false,
          // Additional useful fields from Outlook events
          bodyPreview: event.bodyPreview || '',
          location: event.location?.displayName || '',
          isAllDay: event.isAllDay || false
        };
      }

      // Helper function to extract phone numbers from event content
      function extractPhoneNumbersFromEvent( event )
      {
        const numbers = [];
        const phoneRegex = /(\+\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}/g;

        // Search in body content
        if ( event.body?.content )
        {
          const matches = event.body.content.match( phoneRegex );
          if ( matches )
          {
            numbers.push( ...matches );
          }
        }

        // Search in body preview
        if ( event.bodyPreview )
        {
          const matches = event.bodyPreview.match( phoneRegex );
          if ( matches )
          {
            numbers.push( ...matches );
          }
        }

        // Search in location
        if ( event.location?.displayName )
        {
          const matches = event.location.displayName.match( phoneRegex );
          if ( matches )
          {
            numbers.push( ...matches );
          }
        }

        // Remove duplicates
        return [ ...new Set( numbers ) ];
      }

      // Helper function to calculate event duration in minutes
      function calculateEventDuration( event )
      {
        if ( !event.start?.dateTime || !event.end?.dateTime ) return 60;

        const start = new Date( event.start.dateTime );
        const end = new Date( event.end.dateTime );

        // Handle all-day events
        if ( event.isAllDay )
        {
          const diffDays = Math.ceil( ( end - start ) / ( 1000 * 60 * 60 * 24 ) );
          return diffDays * 24 * 60; // Convert days to minutes
        }

        // Regular events
        const diffMs = end - start;
        return Math.round( diffMs / ( 1000 * 60 ) ); // Convert ms to minutes
      }
      console.log( "transformedMeetings", transformedMeetings );
      setMeetings( transformedMeetings );
    }
  };

  /**
   * Fetches all users from the backend and updates the users state.
   *
   * @async
   * @returns {Promise<void>}
   */
  const fetchUsers = async () =>
  {
    const res = await Get(
      `${apiUrl}/api/v1/users/all`,
      accessToken,
      companyId,
      true,
      ( err ) =>
      {
        console.error( 'User Fetch Error:', err );
      },
    );
    if ( res?.data )
    {
      console.log( 'users milee', res.data );
      setUsers( res.data );
    }
  };

  useEffect( () =>
  {
    const loadData = async () =>
    {
      setIsLoading( true );
      try
      {
        await Promise.all( [ fetchMeetings(), fetchUsers() ] );
      } catch ( error )
      {
        console.error( 'Error loading data:', error );
      } finally
      {
        setIsLoading( false );
      }
    };

    loadData();
  }, [] );

  /**
   * Returns a list of unsynced meeting summaries (future meetings).
   *
   * @returns {Array}
   */
  const getUnsyncedSummaries = () =>
  {
    const now = new Date();
    console.log("meetings-",meetings);
    console.log("now-",now);
    return meetings

      // .filter( ( meeting ) => meeting.date > now )

      .map( ( meeting ) => ( {
        id: meeting.id,

        title: meeting.title,

        type: 'Meeting',

        date: meeting.date.toISOString().split( 'T' )[ 0 ],

        description: `Duration: ${meeting.duration} minutes`,

        host: `Host: ${meeting.organizerEmail}`,

        contact: meeting.emails.filter( e => e.toLowerCase() !== meeting.organizerEmail.toLowerCase() ).join( ', ' ),

        status: 'Pending',

        meetingData: meeting,
      } ) );
  };

//   const getUnsyncedSummaries = () => {
//   const now = new Date();
//   console.log("meetings-", meetings);
//   console.log("now-", now);
  
//   return meetings
//     // .filter((meeting) => {
//     //   // Convert meeting date to user's timezone for comparison
//     //   const meetingDate = new Date(meeting.date);
//     //   const meetingInUserTz = new Date(
//     //     meetingDate.toLocaleString('en-US', { timeZone: timezone })
//     //   );
      
//     //   return meetingInUserTz > now;
//     // })
//     .map((meeting) => ({
//       id: meeting.id,
//       title: meeting.title,
//       type: 'Meeting',
//       date: new Date(meeting.date).toISOString().split('T')[0],
//       description: `Duration: ${meeting.duration} minutes`,
//       host: `Host: ${meeting.organizerEmail}`,
//       contact: meeting.emails.filter(e => 
//         e.toLowerCase() !== meeting.organizerEmail.toLowerCase()
//       ).join(', '),
//       status: 'Pending',
//       meetingData: meeting,
//     }));
// };

  /**
   * Navigates to the previous period (month, week, or day) in the calendar.
   */
  const prevPeriod = () =>
  {
    const newDate = new Date( currentDate );

    if ( activeView === 'month' )
    {
      newDate.setMonth( newDate.getMonth() - 1 );
    } else if ( activeView === 'week' )
    {
      newDate.setDate( newDate.getDate() - 7 );
    } else if ( activeView === 'day' )
    {
      newDate.setDate( newDate.getDate() - 1 );
    }

    setCurrentDate( newDate );
  };

  /**
   * Navigates to the next period (month, week, or day) in the calendar.
   */
  const nextPeriod = () =>
  {
    const newDate = new Date( currentDate );

    if ( activeView === 'month' )
    {
      newDate.setMonth( newDate.getMonth() + 1 );
    } else if ( activeView === 'week' )
    {
      newDate.setDate( newDate.getDate() + 7 );
    } else if ( activeView === 'day' )
    {
      newDate.setDate( newDate.getDate() + 1 );
    }

    setCurrentDate( newDate );
  };

  /**
   * Sets the calendar to today's date.
   */
  const goToday = () =>
  {
    setCurrentDate( new Date() );
  };

  /**
   * Handles clicking on a day in the calendar, sets active view to day.
   *
   * @param {object} dayObj - The day object containing day, month, year, and currentMonth.
   */
  const handleDayClick = ( dayObj ) =>
  {
    if ( !dayObj.currentMonth ) return;

    setActiveView( 'day' );

    setCurrentDate( new Date( dayObj.year, dayObj.month, dayObj.day ) );
  };

  /**
   * Generates the days to display in the month view calendar grid.
   *
   * @returns {Array}
   */
  const generateCalendarDays = () =>
  {
    const year = currentDate.getFullYear();

    const month = currentDate.getMonth();

    const firstDayOfMonth = new Date( year, month, 1 );

    const lastDayOfMonth = new Date( year, month + 1, 0 );

    const startDayIndex = firstDayOfMonth.getDay();

    const daysInMonth = lastDayOfMonth.getDate();

    const prevMonthLastDay = new Date( year, month, 0 ).getDate();

    const calendarDays = [];

    for ( let i = startDayIndex - 1; i >= 0; i-- )
    {
      calendarDays.push( {
        day: prevMonthLastDay - i,

        currentMonth: false,

        month: month - 1,

        year: month === 0 ? year - 1 : year,
      } );
    }

    for ( let i = 1; i <= daysInMonth; i++ )
    {
      calendarDays.push( {
        day: i,

        currentMonth: true,

        month,

        year,
      } );
    }

    const remainingDays = 42 - calendarDays.length;

    for ( let i = 1; i <= remainingDays; i++ )
    {
      calendarDays.push( {
        day: i,

        currentMonth: false,

        month: month + 1,

        year: month === 11 ? year + 1 : year,
      } );
    }

    return calendarDays;
  };

  /**
   * Generates the days for the current week.
   *
   * @returns {Array<Date>}
   */
  const generateWeekDays = () =>
  {
    const startOfWeek = new Date( currentDate );

    startOfWeek.setDate( currentDate.getDate() - currentDate.getDay() );

    return Array.from( { length: 7 } ).map( ( _, i ) =>
    {
      const day = new Date( startOfWeek );

      day.setDate( startOfWeek.getDate() + i );

      return day;
    } );
  };

  /**
   * Generates an array of hours (0-23) for the day view.
   *
   * @returns {Array<number>}
   */
  const generateDayHours = () =>
  {
    return Array.from( { length: 24 } ).map( ( _, i ) => i );
  };


  const getMeetingsForDay = ( day, month, year ) =>
  {
    return meetings.filter( ( meeting ) =>
    {
      // const meetingDateInUserTz = new Date(
      //   meeting.utcDate.toLocaleString('en-US', { timeZone: timezone })
      // );
      const meetingDateInUserTz = new Date(
        meeting.utcDate
      );

      return (
        meetingDateInUserTz.getDate() === day &&
        meetingDateInUserTz.getMonth() === month &&
        meetingDateInUserTz.getFullYear() === year
      );
    } );
  };

  const getMeetingsForDate = ( date ) =>
  {
    return meetings.filter( ( meeting ) =>
    {
      const meetingDateInUserTz = new Date(
        meeting.utcDate.toLocaleString( 'en-US', { timeZone: timezone } )
      );

      return (
        meetingDateInUserTz.getDate() === date.getDate() &&
        meetingDateInUserTz.getMonth() === date.getMonth() &&
        meetingDateInUserTz.getFullYear() === date.getFullYear()
      );
    } );
  };

  const getMeetingsForHour = ( date, hour ) =>
  {
    return getMeetingsForDate( date ).filter( ( meeting ) =>
    {
      const meetingDateInUserTz = new Date(
        meeting.utcDate.toLocaleString( 'en-US', { timeZone: timezone } )
      );

      return meetingDateInUserTz.getHours() === hour;
    } );
  };

  /**
   * Formats the header date string for the current calendar view.
   *
   * @returns {string}
   */
  const formatHeaderDate = () =>
  {
    if ( activeView === 'month' )
    {
      return currentDate.toLocaleDateString( 'en-US', {
        month: 'long',

        year: 'numeric',
      } );
    } else if ( activeView === 'week' )
    {
      const startOfWeek = new Date( currentDate );

      startOfWeek.setDate( currentDate.getDate() - currentDate.getDay() );

      const endOfWeek = new Date( startOfWeek );

      endOfWeek.setDate( startOfWeek.getDate() + 6 );

      return `${startOfWeek.toLocaleDateString( 'en-US', { month: 'short', day: 'numeric' } )} – 

              ${endOfWeek.toLocaleDateString( 'en-US', { month: 'short', day: 'numeric', year: 'numeric' } )}`;
    } else if ( activeView === 'day' )
    {
      return currentDate.toLocaleDateString( 'en-US', {
        weekday: 'long',

        month: 'long',

        day: 'numeric',

        year: 'numeric',
      } );
    }
  };

  /**
   * Renders the month view calendar grid.
   *
   * @returns {JSX.Element}
   */

  const formatTimeForUserTimezone = ( date ) =>
  {
    return date.toLocaleTimeString( 'en-US', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezone,
    } );
  };

  const formatDateForUserTimezone = ( date ) =>
  {
    return date.toLocaleDateString( 'en-US', {
      timeZone: timezone,
    } );
  };

  const renderMonthView = () =>
  {
    const calendarDays = generateCalendarDays();

    const weeks = [];

    for ( let i = 0; i < calendarDays.length; i += 7 )
    {
      weeks.push( calendarDays.slice( i, i + 7 ) );
    }

    return (
      <div className="calendar-grid">
        <div className="weekday-header">
          {[ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ].map( ( day ) => (
            <div key={day} className="weekday">
              {day}
            </div>
          ) )}
        </div>

        <div className="calendar-days">
          {weeks.map( ( week, weekIndex ) => (
            <div className="week" key={weekIndex}>
              {week.map( ( dayObj, dayIndex ) =>
              {
                const dayMeetings = getMeetingsForDay(
                  dayObj.day,

                  dayObj.month,

                  dayObj.year,
                );

                const today = new Date();

                const isToday =
                  dayObj.day === today.getDate() &&
                  dayObj.month === today.getMonth() &&
                  dayObj.year === today.getFullYear();

                return (
                  <div
                    key={dayIndex}
                    className={`day-cell ${!dayObj.currentMonth ? 'other-month' : ''} ${isToday ? 'today' : ''}`}
                    onClick={() => handleDayClick( dayObj )}
                  >
                    <div className="day-number">{dayObj.day}</div>

                    <div className="day-events">
                      {dayMeetings.slice( 0, 2 ).map( ( meeting ) => (
                        <div
                          className={`event-dot ${meeting.type}`}
                          key={meeting.id}
                          title={`${meeting.title} at ${meeting.time}`}
                          onClick={( e ) =>
                          {
                            e.stopPropagation();

                            handleMeetingClick( meeting );
                          }}
                        >
                          {/*<span className="event-time">{meeting.time}{timezone}</span>{' '}*/}
                          <span className="event-time">{meeting.time}</span>{' '}
                          {meeting.title}
                        </div>
                      ) )}

                      {dayMeetings.length > 2 && (
                        <div className="more-events">
                          +{dayMeetings.length - 2} more
                        </div>
                      )}
                    </div>
                  </div>
                );
              } )}
            </div>
          ) )}
        </div>
      </div>
    );
  };

  /**
   * Renders the week view calendar grid.
   *
   * @returns {JSX.Element}
   */
  const renderWeekView = () =>
  {
    const weekDays = generateWeekDays();

    return (
      <div className="week-view-container">
        <div className="week-header">
          <div className="time-column-header"></div>

          {weekDays.map( ( day, index ) =>
          {
            const isToday = day.toDateString() === new Date().toDateString();

            return (
              <div
                key={index}
                className={`day-header ${isToday ? 'today' : ''}`}
                onClick={() =>
                {
                  setCurrentDate( day );

                  setActiveView( 'day' );
                }}
              >
                <div className="day-name">
                  {day.toLocaleDateString( 'en-US', { weekday: 'short' } )}
                </div>

                <div className="day-date">{day.getDate()}</div>
              </div>
            );
          } )}
        </div>

        <div className="week-body">
          {generateDayHours().map( ( hour ) =>
          {
            const hour12 = hour % 12 === 0 ? 12 : hour % 12;

            const ampm = hour >= 12 ? 'pm' : 'am';

            return (
              <div key={hour} className="week-hour-row">
                <div className="time-label">
                  {hour12}

                  {ampm}
                </div>

                {weekDays.map( ( day, dayIndex ) =>
                {
                  const meetings = getMeetingsForHour( day, hour );

                  return (
                    <div
                      key={dayIndex}
                      className="week-hour-cell"
                      onClick={() =>
                      {
                        setCurrentDate( day );

                        setActiveView( 'day' );
                      }}
                    >
                      {meetings.map( ( meeting ) => (
                        <div
                          key={meeting.id}
                          className={`week-event ${meeting.type}`}
                          onClick={( e ) =>
                          {
                            e.stopPropagation();

                            handleMeetingClick( meeting );
                          }}
                        > <span className="event-time">
                            {meeting.time}
                          </span>{' '}
                          {meeting.title}
                        </div>
                      ) )}
                    </div>
                  );
                } )}
              </div>
            );
          } )}
        </div>
      </div>
    );
  };

  /**
   * Renders the day view calendar grid.
   *
   * @returns {JSX.Element}
   */
  const renderDayView = () =>
  {
    const day = currentDate;

    return (
      <div className="day-view-container">
        <div className="day-header">
          <div className="day-name">
            {day.toLocaleDateString( 'en-US', { weekday: 'long' } )}
          </div>

          <div className="day-date">
            {day.toLocaleDateString( 'en-US', {
              month: 'long',

              day: 'numeric',

              year: 'numeric',
            } )}
          </div>
        </div>

        <div className="day-body">
          {generateDayHours().map( ( hour ) =>
          {
            const hour12 = hour % 12 === 0 ? 12 : hour % 12;

            const ampm = hour >= 12 ? 'pm' : 'am';

            const meetings = getMeetingsForHour( day, hour );

            return (
              <div key={hour} className="day-hour-row">
                <div className="time-label">
                  {hour12}

                  {ampm}
                </div>

                <div className="day-hour-cell">
                  {meetings.map( ( meeting ) => (
                    <div
                      key={meeting.id}
                      className={`day-event ${meeting.type}`}
                      onClick={( e ) =>
                      {
                        e.stopPropagation();

                        handleMeetingClick( meeting );
                      }}
                    >
                      <span className="event-time">{meeting.time}</span>{' '}
                      {meeting.title}
                    </div>
                  ) )}
                </div>
              </div>
            );
          } )}
        </div>
      </div>
    );
  };

  /**
   * Handles clicking on a meeting to show its details dialog.
   *
   * @param {object} meeting - The meeting object.
   */
  const handleMeetingClick = ( meeting ) =>
  {
    setSelectedMeeting( meeting );

    setShowMeetingDialog( true );
  };

  /**
   * Handles clicking to assign a summary to a contact.
   *
   * @param {object} summary - The summary object.
   */
  const handleAssignClick = ( summary ) =>
  {
    console.log( "summary---", summary );
    setSelectedSummary( summary );

    setShowAssignDialog( true );
  };

  /**
   * Redirects the user to the Outlook login page for authentication.
   */
  const handleOutlookLogin = () =>
  {
    if ( !userId )
    {
      alert( 'User ID not found in localStorage' );

      return;
    }

    startOutlookLogin(accessToken);
  };

  /**
   * Handles Zoom login/authentication and stores the access token.
   *
   * @async
   * @returns {Promise<void>}
   */
  const handleLogin = async () =>
  {
    if ( !userId )
    {
      alert( 'User ID not found in localStorage' );

      return;
    }

    setIsLoading( true );

    try
    {
      // Signed in, and the Zoom token stays on the server: the page only keeps a "connected" flag.
      const response = await axios.get( `${apiUrl}/api/v1/zoom/auth`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      } );
      if ( response?.data?.connected || response?.data?.access_token )
      {
        localStorage.setItem( 'zoom_access_token', 'connected' );
        setZoomToken( 'connected' );
        alert( 'Zoom authentication successful!' );
        // Optionally, update UI or fetch meetings here
      } else
      {
        alert( 'Failed to authenticate with Zoom.' );
      }
    } catch ( error )
    {
      console.error( 'Error during Zoom authentication:', error );
      alert( 'Error during Zoom authentication.' );
    } finally
    {
      setIsLoading( false );
    }
  };



  // Add this new state for tab handling
  const [ activeTab, setActiveTab ] = useState( 0 );

  // Add this handler for tab changes
  const handleTabChange = ( event, newValue ) =>
  {
    setActiveTab( newValue );
  };

  const handleOutlookLogout = async () =>
  {
    setIsLoading( true );
    try
    {
      const response = await axios.get( `${apiUrl}/outlook/logout`, outlookAuth( accessToken ) );

      if ( response.data.success )
      {
        dispatch( setOutlookAuthenticated( false ) );
        sessionStorage.setItem( 'outlook-callback-ran', '0' );
        // Dispatch action to update Redux state if you're using it
        // dispatch({ type: 'LOGOUT_OUTLOOK' });
        alert( 'Successfully logged out from Outlook' );
        // You may want to refresh the data or redirect
        // window.location.reload(); // Simple refresh
      }
    } catch ( error )
    {
      console.error( 'Error during Outlook logout:', error );
      alert( 'Failed to logout from Outlook' );
      dispatch( setOutlookAuthenticated( false ) );
    } finally
    {
      setIsLoading( false );
    }
  };

  const handleZoomLogout = async () =>
  {
    setIsLoading( true );
    try
    {
      const response = await axios.get( `${apiUrl}/api/v1/zoom/logout`, {
        params: { user_id: userId },
        headers: { Authorization: `Bearer ${ accessToken }` },
      } );

      if ( response.data.success )
      {
        localStorage.setItem( 'zoom_access_token', '' );
        setZoomToken( '' );
        alert( 'Successfully logged out from Zoom' );
      }
    } catch ( error )
    {
      console.error( 'Error during Zoom logout:', error );
      alert( 'Failed to logout from Zoom' );
    } finally
    {
      setIsLoading( false );
    }
  };

  return (
    <SideBarSkeleton>
      {isLoading && <Loader />}

      <div className="zoom-widget-container">
        <div className="zoom-widget">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                mb: 2,
              }}
            >
              <Tab label="Calendar" />
              <Tab label="Meeting" />
              {/* <Tab label="Outlook" /> */}
            </Tabs>

            {activeTab === 0 && outlookAuthenticated && (
              <Button
                variant="contained"
                color="error"
                onClick={handleOutlookLogout}
                sx={{
                  marginLeft: 'auto',
                  padding: '6px 16px',
                  fontSize: '14px',
                  textTransform: 'none',
                }}
              >
                Logout from Outlook
              </Button>
            )}

            {activeTab === 1 && zoomToken && (
              <Button
                variant="contained"
                color="error"
                onClick={handleZoomLogout}
                sx={{
                  marginLeft: 'auto',
                  padding: '6px 16px',
                  fontSize: '14px',
                  textTransform: 'none',
                }}
              >
                Logout from Zoom
              </Button>
            )}
          </div>

          {activeTab === 0 && (
            <div className="zoom-content">
              {!outlookAuthenticated ? (
                <Box
                  sx={{
                    maxWidth: 800,
                    mx: 'auto',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '300px',
                  }}
                >
                  <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                    Please connect your Outlook account to schedule meetings
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={handleOutlookLogin}
                    sx={{
                      backgroundColor: '#0072C6',
                      fontFamily: "'Open Sans', sans-serif",
                      fontWeight: '500',
                      '&:hover': {
                        backgroundColor: '#005A9E',
                      },
                      padding: '10px 20px',
                      fontSize: '16px',
                    }}
                  >
                    Login with Outlook
                  </Button>
                </Box>
              ) : (
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div className="calendar-section">
                    <div className="calendar-header">
                      <div className="calendar-nav">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={prevPeriod}
                        >
                          &lt;
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={goToday}
                        >
                          Today
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={nextPeriod}
                        >
                          &gt;
                        </Button>
                      </div>

                      <div className="calendar-title">{formatHeaderDate()}</div>

                      <div className="view-options">
                        <Button
                          variant={
                            activeView === 'month' ? 'contained' : 'outlined'
                          }
                          color="primary"
                          onClick={() => setActiveView( 'month' )}
                        >
                          Month
                        </Button>
                        <Button
                          variant={
                            activeView === 'week' ? 'contained' : 'outlined'
                          }
                          color="primary"
                          onClick={() => setActiveView( 'week' )}
                        >
                          Week
                        </Button>
                        <Button
                          variant={
                            activeView === 'day' ? 'contained' : 'outlined'
                          }
                          color="primary"
                          onClick={() => setActiveView( 'day' )}
                        >
                          Day
                        </Button>
                      </div>
                    </div>

                    <div className="calendar-view-container">
                      {activeView === 'month' && renderMonthView()}
                      {activeView === 'week' && renderWeekView()}
                      {activeView === 'day' && renderDayView()}
                    </div>
                  </div>

                  {/* Right side summaries section */}
                  <div className="summaries-section">
                      <h3>Edit Meeting Participants</h3>
                    <div className="summaries-list">
                      
                      {/*{getUnsyncedSummaries().map( ( summary ) => (
                        <div key={summary.id} className="summary-card">
                          <div className="summary-header">
                            <h4 className="summary-title">{summary.title}</h4>
                            <span className="summary-type">{summary.type}</span>
                          </div>
                          <div className="summary-date">{summary.date}</div>
                          <div className="summary-description">
                            {summary.description}
                          </div>
                          <h4 className="summary-description">{summary.host}</h4>
                          {summary.contact && (
                            <div className="summary-contact">
                              <strong>Contacts:</strong> {summary.contact}
                            </div>
                          )}
                          <Button
                            variant="contained"
                            color="primary"
                            className="assign-btn"
                            onClick={() => handleAssignClick( summary )}
                          >
                            Assign to Contact
                          </Button>
                        </div>
                      ) )}*/}

                      <div className="summaries-list">
  {getUnsyncedSummaries().length === 0 ? (
    <div className="no-meetings">No meetings requiring assignment</div>
  ) : (
    getUnsyncedSummaries().map( ( summary ) => (
      <div key={summary.id} className="summary-card">
        <div className="summary-header">
          <h4 className="summary-title">{summary.title}</h4>
          <span className="summary-type">{summary.type}</span>
        </div>
        <div className="summary-date">{summary.date}</div>
        <div className="summary-description">
          {summary.description}
        </div>
        <h4 className="summary-description">{summary.host}</h4>
        {summary.contact && (
          <div className="summary-contact">
            <strong>Contacts:</strong> {summary.contact}
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          className="assign-btn"
          onClick={() => handleAssignClick( summary )}
        >
          Assign to Contact
        </Button>
      </div>
    ) )
  )}
</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 1 && (
            <CreateMeeting zoomToken={zoomToken} setIsLoading={setIsLoading} onLogin={handleLogin} />
          )}
          {/* {activeTab === 2 && <Outlook />} */}

          {showMeetingDialog && selectedMeeting && (
            <MeetingDetailsDialog
              meeting={selectedMeeting}
              users={users}
              timezone={timezone}
              onClose={() => setShowMeetingDialog( false )}
            />
          )}

          {showAssignDialog && selectedSummary && (
            <AssignContactDialog
              summary={selectedSummary}
              users={users}
              userId={userId}
              onClose={() => setShowAssignDialog( false )}
              onAssign={async ( selectedEmails ) =>
              {
                setMeetings( ( prev ) =>
                  prev.map( ( meeting ) =>
                    meeting.id === selectedSummary.meetingData.id
                      ? { ...meeting, emails: selectedEmails }
                      : meeting,
                  ),
                );

                setShowAssignDialog( false );

                const loadData = async () =>
                {
                  setIsLoading( true );
                  try
                  {
                    await Promise.all( [ fetchMeetings(), fetchUsers() ] );
                  } catch ( error )
                  {
                    console.error( 'Error refreshing data:', error );
                  } finally
                  {
                    setIsLoading( false );
                  }
                };

                loadData();
              }}
            />
          )}
        </div>
      </div>
    </SideBarSkeleton>
  );
};

export default Zoom;
